export class ClientRepository implements IClientRepository {

    private httpService: IHttpService;

    constructor(instance: IHttpService) {
        this.httpService = instance;
    }

    async getClients(): Promise<OAuthClient[]> {
        const response = await this.httpService.get<Data<OAuthClient[]> | OAuthClient[]>('/v1/client');

        if (Array.isArray(response)) {
            return response;
        }

        return response.data ?? [];
    }

    async createClient(data: ClientCreatePayload): Promise<ClientCreateResult> {
        return await this.httpService.post<ClientCreateResult, ClientCreatePayload>('/v1/client', { data });
    }

    async deleteClient(clientId: string): Promise<ClientDeleteResponse> {
        return await this.httpService.delete<ClientDeleteResponse>(`/v1/client/${clientId}`);
    }
}
